import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import SectionHeading from '../section-heading/index.jsx'
import SettingsEditField from '../settings-edit-field/index.jsx'
import {
  hasShortSessionSelector,
  userEmailSelector,
} from '../../../../../shared/app/bundles/user/index.js'
import { accountsMessages } from '../../../../../shared/app/messages/index.js'
import messages from './messages.js'

export const AccountSection = ({ hasShortSession, userEmailAddress }) => {
  const emailHost = userEmailAddress.slice(userEmailAddress.indexOf('@'))
  const maskedEmail = `•••••${emailHost}`
  const emailAddress = hasShortSession ? userEmailAddress : maskedEmail

  return (
    <React.Fragment>
      <SectionHeading {...messages.accountHeading} />
      <div className="pt3" data-e2e="account-email">
        <SettingsEditField
          label={<FormattedMessage {...messages.emailLabel} />}
          path="/account/settings/edit-email"
          value={emailAddress}
        />
      </div>
      <div className="pt2 pb1" data-e2e="account-password">
        <SettingsEditField
          label={<FormattedMessage {...accountsMessages.password} />}
          path="/account/settings/password"
          value="••••••••"
        />
      </div>
    </React.Fragment>
  )
}

const select = (state) => ({
  hasShortSession: hasShortSessionSelector(state),
  userEmailAddress: userEmailSelector(state),
})

export default connect(select)(AccountSection)
